import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import CoinImage from '@/images/growth/Coin.webp';
import { Coupon } from '@/models/Product';
import getDate from '@/utils/helpers/getDate';
import Percentage from '../icons/Percentage';
function OfferCard({
  offer,
  containerClass
}: {
  offer?: Coupon;
  containerClass?: string;
}) {
  const {
    t
  } = useTranslation('products');
  const today = new Date();
  const expiry = new Date(offer?.expiryDate || '');
  const diffMs = expiry?.getTime() - today.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  return <div className={`flex flex-col justify-center font-semibold tracking-tight leading-[143%] ${containerClass}`} data-sentry-component="OfferCard" data-sentry-source-file="OfferCard.tsx">
      <div className="flex py-0.5 px-2 gap-2 self-start relative pr-6 bg-contain ml-1" style={{
      backgroundImage: `url('/assets/images/growth/RectangleBackground.webp')`
    }}>
        <Image src={CoinImage} alt="Coin" className="w-4 h-4 aspect-square my-0.5" placeholder="blur" data-sentry-element="Image" data-sentry-source-file="OfferCard.tsx" />
        <p className="font-noto-sans font-semibold text-sm leading-[20.02px] tracking-tight text-white">
          {t('offer_for_you')}
        </p>
      </div>

      <div className="relative w-full max-w-[400px]">
        <svg viewBox="0 0 400 140" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-sentry-element="svg" data-sentry-source-file="OfferCard.tsx">
          <defs data-sentry-element="defs" data-sentry-source-file="OfferCard.tsx">
            <clipPath id="couponClip" data-sentry-element="clipPath" data-sentry-source-file="OfferCard.tsx">
              <path d="
            M20,0
            H380
            a20,20 0 0 1 20,20
            V50
            a20,20 0 0 0 0,40
            V120
            a20,20 0 0 1 -20,20
            H20
            a20,20 0 0 1 -20,-20
            V90
            a20,20 0 0 0 0,-40
            V20
            a20,20 0 0 1 20,-20
            Z
          " data-sentry-element="path" data-sentry-source-file="OfferCard.tsx" />
            </clipPath>
          </defs>
          <rect width="400" height="140" fill="white" clipPath="url(#couponClip)" data-sentry-element="rect" data-sentry-source-file="OfferCard.tsx" />

          <path d="
        M20,0
        H380
        a20,20 0 0 1 20,20
        V55
        a8,8 0 0 0 0,30
        V120
        a20,20 0 0 1 -20,20
        H20
        a20,20 0 0 1 -20,-20
        V85
        a8,8 0 0 0 0,-30
        V20
        a20,20 0 0 1 20,-20
        Z
      " fill="none" stroke="#B8255F" strokeWidth="2" strokeDasharray="6 5" strokeLinecap="round" strokeLinejoin="round" shapeRendering="geometricPrecision" data-sentry-element="path" data-sentry-source-file="OfferCard.tsx" />

          <foreignObject x="0" y="0" width="400" height="140" clipPath="url(#couponClip)" data-sentry-element="foreignObject" data-sentry-source-file="OfferCard.tsx">
            <div className="flex items-center px-6 py-4 gap-x-10 viewBox box-border">
              <div>
                <p className="text-[#B8255F] text-2xl font-extrabold tracking-tight">
                  {t('discount_caption', {
                  amount: offer?.offer_type === "PERCENTAGE" ? `${offer?.offer_value}%` : offer?.offer_type === "DISCOUNT_AMOUNT" ? `₹${offer?.offer_value}` : offer?.offer_value
                })}
                </p>
                <p className="text-xl font-extrabold tracking-tight">{offer?.couponCode}</p>
                <p className="text-neutral-700 text-sm mt-1">
                  {offer?.description}
                </p>
                {diffDays <= 30 && <p className="text-neutral-700 text-sm mt-1">
                  Validity till: {getDate(offer?.expiryDate ?? null, false)}</p>}
              </div>
              <Percentage width="80" height="80" data-sentry-element="Percentage" data-sentry-source-file="OfferCard.tsx" />
            </div>
          </foreignObject>
        </svg>
      </div>

    </div>;
}
export default OfferCard;